import { render, staticRenderFns } from "./BreadcrumbNav.vue?vue&type=template&id=2d65e998&scoped=true"
import script from "./BreadcrumbNav.vue?vue&type=script&lang=js"
export * from "./BreadcrumbNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d65e998",
  null
  
)

export default component.exports